// Canal de comunicación entre el selector de versiones de la ficha de modelo y
// los bloques que deben seguir esa selección (ej. la calculadora de ahorro).
//
// Los componentes viven en bundles distintos, así que el estado compartido se
// guarda en `window` (no basta con una variable de módulo) y el aviso viaja como
// CustomEvent en `document`. El último valor queda publicado para los bloques
// que montan después de que el selector ya eligió versión.

export const VEHICLE_VERSION_EVENT = "vehicle:version-selected";

const STORE_KEY = "__toyotaSelectedVersion";

// selection: { id, name, motor, image }
export const publishVersionSelection = (selection) => {
    if (!selection || !selection.id) return;
    window[STORE_KEY] = selection;
    document.dispatchEvent(
        new CustomEvent(VEHICLE_VERSION_EVENT, { detail: selection }),
    );
};

export const getCurrentVersionSelection = () => window[STORE_KEY] || null;

// Devuelve la función para desuscribirse (pensado para el cleanup de useEffect).
export const subscribeToVersionSelection = (handler) => {
    const listener = (event) => handler(event.detail);
    document.addEventListener(VEHICLE_VERSION_EVENT, listener);
    return () => document.removeEventListener(VEHICLE_VERSION_EVENT, listener);
};
